import { register } from '@onpace/onspace-core/components/translations'

register({
  "en": {
    "onspace": {
      "cms": {
        "actions": {
          "input": {
            "placeholder": "Search..."
          },
          "results": {
            "loading": "Loading...",
            "recent": "Recent Items",
            "none": "No results",
            "full_results": "Full Results"
          },
          "error": {
            "unknown": "An unknown error occurred"
          }
        },
        "interactions": {
          "connection": {
            "offline": "Unable to connect to server"
          },
          "subscribers": {
            "anonymous": {
              "name": "Anonymous",
              "initial": "Ay"
            },
            "online": {
              "singular": "%{count} other user is viewing this:",
              "plural": "%{count} other users are viewing this:"
            }
          }
        }
      }
    }
  }
})
